import { OktaAuthConfig } from "./types";
import OktaAuth from "@okta/okta-auth-js";

const config = window.OKTA_CONFIG.account;
const {
  VITE_OKTA_ACCOUNT_LEGACY_CLIENT_ID,
  VITE_OKTA_ISSUER,
  VITE_OKTA_ACCOUNT_LEGACY_REDIRECT_URI,
} = import.meta.env;
export const accountAuthConfig: OktaAuthConfig = {
  clientId: VITE_OKTA_ACCOUNT_LEGACY_CLIENT_ID || config.clientId,
  issuer: VITE_OKTA_ISSUER || config.issuer,
  redirectUri: VITE_OKTA_ACCOUNT_LEGACY_REDIRECT_URI || config.redirectUri,
};

export const getOktaAccountAuthObject = (authConfig: OktaAuthConfig) => {
  const { clientId, issuer, redirectUri } = authConfig;

  return new OktaAuth({
    clientId,
    cookies: {
      secure: true,
      sessionCookie: true,
    },
    issuer,
    redirectUri: `${window.location.origin}${redirectUri}`,
    scopes: ["email", "openid", "profile"],
    tokenManager: {
      storage: "cookie",
      storageKey: `instl-${clientId.slice(-6)}-token-storage`,
    },
  });
};
